// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { APP_VERSION } from './version';

function getApiBaseUrl(): string {
  const w = window as any;
  return (w && w.env && w.env.API_BASE_URL) || "http://localhost:8080";
}

function getGoogleClientId(): string {
  const w = window as any;
  return (w && w.env && w.env.GOOGLE_CLIENT_ID) || '';
}

function getGoogleRedirectUri(): string {
  const w = window as any;
  return (w && w.env && w.env.GOOGLE_REDIRECT_URI) || '';
}

function getAmazonClientId(): string {
  const w = window as any;
  return (w && w.env && w.env.AMAZON_CLIENT_ID) || '';
}

function getAmazonRedirectUri(): string {
  const w = window as any;
  return (w && w.env && w.env.AMAZON_REDIRECT_URI) || '';
}

export const environment = {
  production: false,
  version: APP_VERSION,
  apiBaseUrl: getApiBaseUrl(),
  STRIPE_PUBLIC_KEY: "pk_test_dbMc9ThV9sHN1kgMTERPIPS0",
  GOOGLE_CLIENT_ID: getGoogleClientId(),
  GOOGLE_REDIRECT_URI: getGoogleRedirectUri(),
  AMAZON_CLIENT_ID: getAmazonClientId(),
  AMAZON_REDIRECT_URI: getAmazonRedirectUri()
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
